import React, { useContext, useEffect, useState, useRef } from 'react';
import EditorContext from '../EditorContext/EditorContext';
import ControlTimeline from '../Controls/ControlTimeline';
import ControlAnimation from '../Controls/ControlAnimation';
import ControlProject from '../Controls/ControlProject';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Iconify from '../Iconify/Iconify';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { createGsapCode } from '../../Utils';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import './Panel.scss';

function Panel() {
  const { page, project, loading, setLoading, timelines, setTimelines, animationCurrent, setAnimationCurrent, openModalExport, setOpenModalExport, setGsapCode, editorTab, setEditorTab, iframeRef } = useContext(EditorContext);
  const { projectId, pageId } = useParams();
  const navigate = useNavigate();

  const handleSave = async () => {
    try {
      setLoading(true);
      const gsapCode = createGsapCode(project, timelines, false);
      setGsapCode(gsapCode);

      const pageOption = {
        method: 'PUT',
        url: '/api/v1/pages/' + page._id,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          ...page,
          timelines: timelines,
          jsLibs: gsapCode.libs,
          jsCode: gsapCode.code,
        },
      };
      await axios(pageOption);

      const projectOption = {
        method: 'PUT',
        url: '/api/v1/projects/' + project._id,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          ...project,
        },
      };
      await axios(projectOption);

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleExport = () => {
    const gsapCode = createGsapCode(project, timelines, false);
    setGsapCode(gsapCode);
    setOpenModalExport(true);
  }

  const renderThumb = () => {
    return (
      <div style={{background: '#1D1D1D'}}/>
    );
  }

  const handleChangeEditorTab = (e: any) => {
    setEditorTab(e.target.value);
  };

  let panelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    panelRef.current?.addEventListener('mouseover', (e: any) => {
      const iframe = iframeRef.current;
      const iframeWindow = iframe?.contentWindow;
      iframeWindow.litemoveSelectorRect({hide: true});
    });
  }, [iframeRef]);

  return (
    <div className="panel" ref={panelRef}>
      <Scrollbars
        style={{ width: 320, minHeight: `100vh` }}
        autoHide
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
      >
        <div className="panel__inner">
          <div className="controls">
            <div style={{padding: '20px'}}>
              <div className="panel__logo">
                <svg width="100%" height="100%" viewBox="0 0 268 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M68 32.9794H84.7191V29.8422H71.5431V6.59052H68V32.9794ZM91.1912 32.9794H94.7343V6.59052H91.1912V32.9794ZM109.823 32.9794H113.366V9.69074H122.003V6.59052H101.224V9.69074H109.823V32.9794ZM128.419 32.9794H146.245V29.916H131.962V21.0582H145.544V17.9949H131.962V9.65384H146.245V6.59052H128.419V32.9794ZM165.488 30.5435H168.146L177.151 11.7427V32.9794H180.584V6.59052H176.302L166.856 26.3579L157.443 6.59052H153.051V32.9794H156.483V11.7427L165.488 30.5435ZM196.094 32.5365C197.767 33.2254 199.6 33.5699 201.593 33.5699C203.586 33.5699 205.419 33.2254 207.092 32.5365C208.766 31.8475 210.23 30.8879 211.484 29.6577C212.739 28.4028 213.711 26.9388 214.4 25.2657C215.089 23.568 215.434 21.7349 215.434 19.7665C215.434 17.7981 215.089 15.9773 214.4 14.3042C213.711 12.631 212.739 11.1793 211.484 9.9491C210.23 8.69424 208.766 7.72235 207.092 7.03341C205.419 6.34447 203.586 6 201.593 6C199.6 6 197.767 6.34447 196.094 7.03341C194.421 7.72235 192.957 8.69424 191.702 9.9491C190.447 11.1793 189.475 12.631 188.786 14.3042C188.097 15.9773 187.753 17.7981 187.753 19.7665C187.753 21.7349 188.097 23.568 188.786 25.2657C189.475 26.9388 190.447 28.4028 191.702 29.6577C192.957 30.8879 194.421 31.8475 196.094 32.5365ZM206.871 29.0303C205.345 29.9406 203.586 30.3958 201.593 30.3958C199.625 30.3958 197.866 29.9406 196.315 29.0303C194.79 28.1199 193.597 26.865 192.735 25.2657C191.899 23.6418 191.481 21.8087 191.481 19.7665C191.481 17.7243 191.899 15.9035 192.735 14.3042C193.597 12.7049 194.79 11.45 196.315 10.5396C197.866 9.62923 199.625 9.17404 201.593 9.17404C203.586 9.17404 205.345 9.62923 206.871 10.5396C208.396 11.45 209.578 12.7049 210.414 14.3042C211.275 15.9035 211.706 17.7243 211.706 19.7665C211.706 21.8087 211.275 23.6418 210.414 25.2657C209.578 26.865 208.396 28.1199 206.871 29.0303ZM229.551 32.9794H233.278L243.575 6.59052H239.885L231.471 28.9811L223.092 6.59052H219.253L229.551 32.9794ZM268 6.53988H250.518V9.45363H268V6.53988ZM245.661 17.2236H263.144V20.1374H245.661V17.2236ZM268 28.8786H250.518V31.7924H268V28.8786Z" fill="white"/>
                <path d="M0 2.40602C0 1.07721 1.07721 0 2.40601 0H37.594C38.9228 0 40 1.07721 40 2.40601V37.594C40 38.9228 38.9228 40 37.594 40H2.40602C1.07721 40 0 38.9228 0 37.594V2.40602Z" fill="#3644EE"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.916 31.25L29.5827 31.25V26.6669H19.5556V8.95831H14.166V8.95833H9.16602V31.25H17.916Z" fill="url(#paint0_linear_299_2056)"/>
                <defs>
                <linearGradient id="paint0_linear_299_2056" x1="38.7493" y1="19.4791" x2="6.5709" y2="19.1403" gradientUnits="userSpaceOnUse">
                <stop offset="0.521348" stop-color="white"/>
                <stop offset="0.912622" stop-color="#3644EE"/>
                </linearGradient>
                </defs>
                </svg>
              </div>
              <div className="controls__field-group controls__field-group--label-block">
                <RadioGroup
                  row
                  className='radio-group'
                  id="editorTab"
                  value={editorTab}
                  onChange={handleChangeEditorTab}
                >
                  <FormControlLabel value="timeline" control={<Radio id="editorTab" />} label="Timeline" />
                  <FormControlLabel value="animation" control={<Radio id="editorTab" />} label="Animation" />
                  <FormControlLabel value="project" control={<Radio id="editorTab" />} label="Project" />
                </RadioGroup>
              </div>
            </div>
          </div>
          {editorTab === 'timeline' && (
            <ControlTimeline />
          )}
          {editorTab === 'animation' && (
            <ControlAnimation />
          )}
          {editorTab === 'project' && (
            <ControlProject />
          )}
          <div className="panel__footer">
            <div className="panel__footer-left">
              <div className="panel__back" onClick={() => {navigate(`/projects/${projectId}`);}}>
                <Iconify icon="material-symbols:keyboard-arrow-left" />
                Project
              </div>
            </div>
            <div className="panel__footer-right flex align-center">
              <LoadingButton loading={loading} variant="contained" className='panel__button-export' onClick={() => handleExport()}>Export</LoadingButton>
              <LoadingButton loading={loading} onClick={handleSave} variant="contained">Save</LoadingButton>
            </div>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
}

export default Panel;
